import { h } from "preact";
import { useNavigate } from "react-router-dom";

import { classNames } from "../../helpers.js";

import Avatar from "../Avatar.jsx";
import UserPositionAndCountry from "../UserPositionAndCountry.jsx";

export default function CandidateItem({ user, ...props }) {
  const navigate = useNavigate();
  function handleClick(event) {
    event.preventDefault();
    navigate(`/relocation/${encodeURIComponent(user.id)}`);
  }

  const numTasks = user.tasks.length || 1;
  const numDoneTasks = user.tasks.filter((task) => task.done).length;

  return (
    <div
      onClick={handleClick}
      class={classNames("company-candidate-item row", props.class)}
    >
      <div class="company-candidate-item__avatar col s1">
        <Avatar user={user} plain medium />
      </div>
      <div class="company-candidate-item__content col s12 l8">
        <h1 class="t-subtitle1 t-subtitle1--margin-small pt-0">{user.name}</h1>
        <UserPositionAndCountry smaller user={user} class="mb-0" />
      </div>
      <div class="company-candidate-item__addition col s12 l3">
        <div class="company-candidate-item__progress">
          <span class="company-candidate-item__progress-value mb-8">
            {Math.floor(100 * (numDoneTasks / numTasks))}%
          </span>
          <span class="company-candidate-item__progress-text">Progress</span>
        </div>
      </div>
    </div>
  );
}
